import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import './CountStepper.css';

interface Props {
  label: string;
  /** Rendered value, e.g. "4" or "50:00" */
  display: string;
  hint?: string;
  onDecrement: () => void;
  onIncrement: () => void;
  canDecrement: boolean;
  canIncrement: boolean;
  ariaLabel?: string;
  /** 'lg' is the report screen's per-player row (Asana 1220065638706450); 'default' is unchanged for existing callers */
  size?: 'default' | 'lg';
  /** Overrides the label-derived data-testid on the value span */
  testId?: string;
  /** Leading player highlight on the report screen (play-stepper--winner) */
  winner?: boolean;
}

/** Minus / value / plus row used for Swiss rounds, the round timer (Decision 7) and the report screen's game counts. */
export const CountStepper: React.FC<Props> = ({ label, display, hint, onDecrement, onIncrement, canDecrement, canIncrement, ariaLabel, size = 'default', testId, winner = false }) => (
  <div className={`play-stepper${size === 'lg' ? ' play-stepper--lg' : ''}${winner ? ' play-stepper--winner' : ''}`} role="group" aria-label={ariaLabel ?? label}>
    <div className="play-stepper__text">
      <span className="play-stepper__label">{label}</span>
      {hint && <span className="play-stepper__hint">{hint}</span>}
    </div>
    <div className="play-stepper__controls">
      <button type="button" className="play-stepper__btn" onClick={onDecrement} disabled={!canDecrement} aria-label={`Decrease ${label}`}>
        <FontAwesomeIcon icon={faMinus} />
      </button>
      <span className="play-stepper__value" data-testid={testId ?? `stepper-${label.toLowerCase().replace(/\s+/g, '-')}`}>
        {display}
      </span>
      <button type="button" className="play-stepper__btn" onClick={onIncrement} disabled={!canIncrement} aria-label={`Increase ${label}`}>
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  </div>
);

export default CountStepper;
